// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
import { loadTextFileAjaxSync } from '../app/core/utils/load-ajax-basic';
import { Environment } from '../app/models/environment';

function loadJSON() {
  if(window.location.origin.includes('localhost')){
    const json = loadTextFileAjaxSync('config/environment.json', 'application/json');
    return JSON.parse(json);
  }
  else{
    const defaultJSON = {"url_api": "https://dev.ivcert.net/ivcert", "apiVersion": "v3"};
    return defaultJSON;
  }
}
export const environment: Environment = loadJSON();
